import { render, staticRenderFns } from "./GoogleMapsIcon.vue?vue&type=template&id=c6945ca6&functional=true&"
import script from "./GoogleMapsIcon.vue?vue&type=script&lang=js&"
export * from "./GoogleMapsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports